export default __webpack_public_path__ + "static/media/left-leafs.d8a48e36.svg";